import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-negociation-devis-negoce',
  templateUrl: './negociation-devis-negoce.component.html',
  styleUrls: ['./negociation-devis-negoce.component.scss']
})
export class NegociationDevisNegoceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
